import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import CSVButton from "../../Reports/CSVButton";
import {
  generateReport,
  ReportTable,
  getTotalPurchases,
} from "../../Reports/generateReport";
import UpdateCode from "./UpdateCode";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: "20px",
    margin: "20px",
    textAlign: "left",
    overflowY: "scroll",
    width: "100%",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
  list: {
    margin: 30,
    width: "400px",
    color: "black",
  },
  cargando: {
    textAlign: "center",
    padding: 40,
  },
}));

function calcularFilaCodigo(a) {
  let available = true;

  if (a.uses && Object.values(a.uses).length >= parseInt(a.maxUses)) {
    available = false;
  }
  if (!a.available) {
    available = false;
  }

  return {
    ...a,
    value:
      a.typeCode === "PercentRegistry" || a.typeCode === "PercentAmount"
        ? a.value * 100 + "%"
        : a.value,
    available: available,
    usesCount:
      a.uses && Object.values(a.uses).length
        ? Object.values(a.uses).length
        : 0,
    fechaFin: a.fechaFin || "No definida",
  };
}

export default function FormReports(props) {
  const { codesGroup, codesIndex } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);

  const [report, setReport] = useState([]);
  const [labels, setLabels] = useState([]);
  const [datosGrupo, setDatosGrupo] = useState([]);
  const [reportType, setReportType] = useState(undefined);
  const [itemIdentifier, setItemIdentifier] = useState(undefined);
  // Empieza en true: mientras no se haya confirmado que terminó de armar la
  // tabla (venga de Firebase o del cálculo pesado de abajo), se muestra
  // "Cargando" en vez de nada o de un "no hay códigos" engañoso.
  const [cargando, setCargando] = useState(true);

  const codesList = useSelector((state) => state.registry.codesList);
  const codesGroups = useSelector((state) => state.registry.codesGroups);
  function detailComponent(item) {
    console.log("item", item);
    return <UpdateCode code={item} codesGroup={codesGroup} />;
  }
  console.log(eventDetail);
  const classes = useStyles();

  useEffect(() => {
    if (!codesList) {
      setCargando(true);
      return;
    }

    setCargando(true);
    // Para grupos con muchos códigos, filtrar+mapear TODO codesList y armar
    // el reporte puede tomar un momento notable. Si se hiciera en el mismo
    // tick que setCargando(true), React nunca alcanza a pintar el mensaje
    // de carga antes de que el cálculo bloquee el hilo — por eso se difiere
    // un tick con setTimeout, así el navegador sí pinta "Cargando..." antes
    // de hacer el trabajo pesado.
    const idTimeout = setTimeout(() => {
      const data = Object.values(codesList)
        .filter((a) => a.codeGroup === codesIndex)
        .map(calcularFilaCodigo);

      const newReport = generateReport({
        data: data,
        fields: [
          { label: "Código", path: "code" },
          { label: "Disponible", path: "available" },
          { label: "Usos permitidos", path: "maxUses" },
          { label: "Veces usado", path: "usesCount" },
          { label: "Tipo de código", path: "typeCode" },
          { label: "Valor", path: "value" },
          { label: "Nota", path: "note" },
          { label: "Fecha límite", path: "fechaFin" },
        ],
      });
      setDatosGrupo(data);
      setLabels(newReport.labels);
      setReport(newReport.report);
      setItemIdentifier(newReport.itemIdentifier);
      setCargando(false);
    }, 0);

    return () => clearTimeout(idTimeout);
  }, [codesList, codesIndex]);

  return (
    <div className={classes.root}>
      <Grid container direction="row" alignItems="center" alignContent="center">
        <Grid item xs={12} alignItems="center">
          {cargando ? (
            <div className={classes.cargando}>
              <CircularProgress />
              <Typography gutterBottom variant={"h6"} component="p" style={{ marginTop: 20 }}>
                Cargando códigos del grupo...
              </Typography>
            </div>
          ) : datosGrupo.length > 0 ? (
            <>
              <CSVButton report={report} labels={labels} />
              <ReportTable
                report={report}
                labels={labels}
                data={datosGrupo}
                reportType={"code"}
                itemIdentifier={itemIdentifier}
                showButtonDetail={true}
                detailComponent={detailComponent}
              />
            </>
          ) : (
            <Typography gutterBottom variant={"h5"} component="h2">
              No hay códigos creados en este grupo
            </Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
